import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PrintassetService } from '../printasset.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { error } from 'jquery';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-print-assest-qr-details',
  templateUrl: './print-assest-qr-details.component.html',
  styleUrls: ['./print-assest-qr-details.component.scss']
})
export class PrintAssestQRDetailsComponent implements OnInit {
  displayedColumns: string[] = ['fusioncode', 'buildingName', 'entity', 'noofassests', 'startingnumber', 'endingnumber', 'status', 'generateqr'];
  dataAvailable = true;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  campusdetails: any;
  CampusId: any;
  buildingDetails: any;
  BuildingId: any;
  tableDetails: any;
  printQRData: any;
  entityQRId: any;
  generatePdfDetails: any;
  ngOnInit(): void {
    this.selectCampusList();
  }
  constructor(private printservice: PrintassetService, private spinner: NgxSpinnerService,private route: ActivatedRoute,) { }

  selectCampusList() {
    this.spinner.show();
    this.printservice.getcampusdetail().subscribe(
      {
        next: (res: any) => {
          this.campusdetails = res;
          console.log('CAMPUS', this.campusdetails);
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }
  onSelectedBuilding(event: any) {
    this.CampusId = event.target.value;
    console.log('this.CampusId', this.CampusId);
    this.spinner.show();
    this.printservice.getbuildingdetail(this.CampusId).subscribe(
      {
        next: (res: any) => {
          this.buildingDetails = res;
          console.log('BuildingDetails', this.buildingDetails);

          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    );
  }

  onSelectedTableList(event: any) {
    this.BuildingId = event.target.value;
    console.log('BuildingId', this.BuildingId);
    this.spinner.show();
    this.printservice.gettabledetail(this.BuildingId).subscribe(
      {
        next: (res: any) => {
          this.tableDetails = res;
          this.printQRData = new MatTableDataSource(this.tableDetails);
          this.printQRData.sort = this.sort;
          this.printQRData.paginator = this.paginator;
          this.dataAvailable = true;
          console.log('TABLE', this.tableDetails);

          this.spinner.hide();
        },
        error: (error: any) => {
          this.dataAvailable = false;
          this.spinner.hide();
        }
      }
    )
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.printQRData.filter = filterValue.trim().toLowerCase();
    console.log('filterValue', filterValue);
  }

  alldata(data: any) {
    this.entityQRId = data.entityQRId;
    console.log('Entity', this.entityQRId);

    this.spinner.show();
    this.printservice.getgeneratepdf(this.entityQRId).subscribe(
      {
        next: (res: Blob) => {
          this.spinner.hide();  // Hide spinner when done
          // Create a download link for the PDF Blob
          const pdfUrl = window.URL.createObjectURL(res);
          console.log('pdfUrl', pdfUrl);
          // Open the PDF in a new tab
          const newTab = window.open();
          if (newTab) {
            // Set the content in the new tab with title and embedded PDF
            newTab.document.write(`
               <html>
                 <head>
                   <title>generateAssetQRCode</title>
                 </head>
                 <body>
                   <embed width="100%" height="100%" src="${pdfUrl}" type="application/pdf" />
                 </body>
               </html>
             `);
          } else {
            console.error('Popup blocked. Please allow popups for this site.');
          }

          setTimeout(() => {
            window.URL.revokeObjectURL(pdfUrl);
          }, 100);  // Revoking after 100ms

        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }









}
